var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "beverages slide", class: { up: !_vm.ready } },
    _vm._l(_vm.beverages, function(beverage) {
      return _c("beverage", { key: beverage.id, attrs: { beverage: beverage } })
    })
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08d864f9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08d864f9","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./src/components/beverages/beverages.html
// module id = 163
// module chunks = 0